import React, {useCallback, useRef} from 'react';
import cx from 'classnames';
import {noop} from '@priority-software/priority-style-react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {FormInput} from '../FormInput/FormInput';
import {Field} from '../../../../stores/Form/Field';
import {Column} from '../../../../stores/Form/Column';
import {cx_menu_input_anchor} from '../FormInput/constants';
import {BIDropdown} from '../BIDropdown';
import {FormActiveElement} from '../../../../stores/Form/Form';
import {createDataTestId} from '../../../../utils/dataTestId';
import styles from './FormView.module.scss';

type Props = {
    column: Column;
    onFocus: (columnIndex: number, el: FormActiveElement) => void;
    searchMode: boolean;
    currentRow: number;
    isActive: boolean;
    currField?: Field;
    searchValue?: string;
    updateSearchValue: (val: string, colId: number, rowIndex: number) => void;
    testId?: string;
};

export const FormControl = (props: Props) => {
    const {
        column,
        onFocus,
        currentRow,
        searchMode,
        isActive,
        currField,
        updateSearchValue,
        searchValue,
        testId
    } = props;
    const inputWrapRef = useRef();
    const booleanInput = column.Type === priority.netitems.form.ColumnType.Boolean;

    const getAnchor = useCallback(() => inputWrapRef.current, []);

    const fieldValue = currField?.currentValue || '';
    const origValue = currField?.origValue || '';

    const handleFocus = useCallback(
        el => {
            onFocus(column.index, el);
        },
        [column, onFocus]
    );

    return (
        <div key={column.id} className={styles.fieldSetRow} {...createDataTestId(testId, false)}>
            <div className={cx(styles.fieldSetLabel)}>
                <span className={cx({'pui-label-required': column.Mandatory})}>{column.Title}</span>
                {false && <BIDropdown column={column} />}
            </div>

            <div className={cx(styles.fieldSetControl, cx_menu_input_anchor)} ref={inputWrapRef}>
                <FormInput
                    getCellWrap={getAnchor}
                    column={column}
                    searchMode={searchMode}
                    rowIndex={currentRow}
                    initValue={searchMode ? searchValue : fieldValue}
                    origValue={origValue}
                    isActive={isActive}
                    updateSearchValue={updateSearchValue}
                    updateCurrentValue={currField?.setCurrentValue}
                    onFocus={handleFocus}
                    openSelectListModal={noop}
                    onMaxWidthMode={noop}
                    componentClasses={booleanInput ? styles.booleanInput : ''}
                />
            </div>
        </div>
    );
};
